import { NotificationTimeDistributionTypes } from '../types';
import { isPast, isWithinInterval } from 'date-fns';
export function epochToTimeDistribution(epoch) {
    if (!epoch) {
        return { distribution: NotificationTimeDistributionTypes.UNKNOWN };
    }
    const now = new Date();
    if (isWithinInterval(now, { start: epoch.start, end: epoch.end })) {
        const duration = epoch.end.getTime() - now.getTime();
        return {
            distribution: NotificationTimeDistributionTypes.NOTIFIABLE,
            duration,
        };
    }
    if (isPast(epoch.end)) {
        return { distribution: NotificationTimeDistributionTypes.PAST };
    }
    const missingTime = epoch.start.getTime() - now.getTime();
    return { distribution: NotificationTimeDistributionTypes.FUTURE, missingTime };
}
//# sourceMappingURL=time-distribution.util.js.map